<app-page-body>
  <!-- header -->
  <app-page-header
    custom-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    [showBackBtn]="false"
    [showRefreshBtn]="false"
    (onRefresh)="onReset()"
  >
    <div class="card-toolbar" after-btns>
      <!-- open sendQueue -->
      <button
        type="button"
        (click)="scrollToSocialMediaDetail()"
        class="btn txt-lg button-shadow tw-mx-1 tw-flex tw-items-center btn-hover-rise"
        [themeColor]="'btn-light'"
        mat-ripple
      >
        <span class="tw-mx-1">{{
          "common.socialMediaGroupPriceDetail" | translate
        }}</span>
      </button>
    </div>
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <app-group-price-details-form
      [groupPrices]="groupPriceDetail"
      [readOnly]="true"
      [showPageHeader]="false"
      [tagName]="tagName"
    >
    </app-group-price-details-form>

    <app-group-price-social-media-detail-form
      id="socialMediaDetails"
      [groupPriceDetail]="groupPriceDetail?.socialMediaDetails"
      [showPageHeader]="false"
      [readOnly]="true"
    ></app-group-price-social-media-detail-form>

    <app-international-group-price></app-international-group-price>
  </div>
</app-page-body>
